import React from "react";
import { Row, Col } from "react-bootstrap";

import "./serviceDataComponent.css";

export const ServiceHeading = ({detailservice}) => {
  const { service } = detailservice;
  return (
    <div>
      <Row className="service-header-row">
        <Col lg={10}>
          <h2 className="service-heading">{service.service}</h2>
        </Col>
      </Row>
    </div>
  );
};
